import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';
import { ModificarCuentaCompromiso } from './modalModificarCuentaCompromiso';
import { formatMoneda } from '../../util/varios';

const TablaModificarCompromisos = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  const espiritu = JSON.parse(localStorage.getItem('espiritu'));

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COMPROMISO Nº', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CONCEPTO', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [tipomov, setTipomov] = useState(0);
  const [compromiso, setCompromiso] = useState();
  const [cuentas, setCuentas] = useState();
  const [movimientosd, setMovimientosd] = useState();
  const [provee, setProvee] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if (x.idcompromiso.includes(target.value)
              || x.concepto.toLowerCase().includes(target.value.toLowerCase())
              || formatMoneda(x.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const SeleccionarRegistros = () => {

    setActivate(true);
    setCompromiso();
    setCuentas();
    let endpoint = `${op.conexion}/api/presupuesto/registroscompromisos?idefiscal=${idefiscal}`
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {
        setRecords(response.data);
        txtBuscador.current.focus();
      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SeleccionarCompromiso = (id, ope) => {

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarcompromiso?idefi=${idefiscal}&operacion=${ope}&&idcompro=${id}&espiritu=${espiritu}`

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        if (response.data.length > 0) {
          setCompromiso(response.data[0]);
          setCuentas(response.data);
          setMostrar2(true);
        } else {
          setCompromiso();
          setCuentas();
        }

      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarCompromiso = (op, data) => (e) => {

    if (op === 4) {
      setOperacion(4);
      SeleccionarCompromiso(data.idcompromiso, op);
    } else if (op === 1) {
      setOperacion(op);
      setTipomov(9);
      setMostrar2(true)
    } else if (op === 2) {

      if (data.reversado > 0) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'El Compromiso ya fue Reversado', icono: 'informacion' });
      } else if (data.status === 2) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'El Compromiso ya fue Pagado', icono: 'informacion' });
      } else {
        setOperacion(op);
        setTipomov(9);
        SeleccionarCompromiso(data.idcompromiso, op);
      }

    } else if (op === 5) {

      if (data.reversado > 0) {
        setOperacion(op);
        setTipomov(9);
        SeleccionarCompromiso(data.idcompromiso, op);
      } else {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'Debe Reversar el Compromiso para poder Eliminar el Registro', icono: 'informacion' });
      }

    }

  }


  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
    setCompromiso();
    setCuentas();
  }

  const cerrar = () => {
    props.menu()
  }

  return (
    <section className='modal-azulGradiant mx-auto col-9'>
      <header className='header-azulGradiant'>
        <h3 >
          Modificar Compromisos

        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input col-3 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />

      </div>

      <div className="col-md-12 m-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '20px' }}>{item.idcompromiso}</td>
                  <td className='align-middle' style={{ textAlign: "left", alignItems: 'left', width: '350px' }}>{item.concepto}</td>
                  <td className='align-middle' style={{ textAlign: "right", alignItems: 'right', width: '70px' }}>{formatMoneda(item.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '80px' }}>
                    <button onClick={gestionarCompromiso(4, item)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i></button>
                    <button onClick={gestionarCompromiso(2, item)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fas fa-edit"></i> </button>
                    {/*<button onClick={gestionarCompromiso(5, item)} className="btn btn-sm mx-1 btn-danger rounded-pill"><i className="fas fa-trash-alt"></i></button>*/}
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModificarCuentaCompromiso
        show={mostrar2}
        operacion={operacion}
        compro={compromiso}
        cuentas={cuentas}
        titulo={operacion === 4 ? 'Consulta Compromiso' : operacion === 2 ? 'Modificar Compromiso' : operacion === 1 ? 'Compromiso' : 'Eliminar Compromiso'}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />


      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaModificarCompromisos;